export const categories = [
  {
    key: "entertainment",
    slug: "entertainment",
    name: "娱乐新闻",
    shortName: "娱乐",
    icon: "ri-star-smile-line",
    description: "精选娱乐圈实时新闻动态与深度报道，聚焦影视、音乐、综艺与明星资讯。",
    tdkTitle: "娱乐新闻 - 51吃瓜官网",
    tdkDescription: "51吃瓜官网娱乐新闻频道，精选娱乐圈实时新闻动态与深度报道，覆盖影视、音乐、综艺及明星热点。",
    tdkKeywords: "娱乐新闻,明星资讯,影视动态,综艺热点,51吃瓜官网",
  },
  {
    key: "society",
    slug: "society",
    name: "社会热点",
    shortName: "社会",
    icon: "ri-building-2-line",
    description: "追踪社会民生热点事件与公共话题，呈现真实、及时、有温度的现场报道。",
    tdkTitle: "社会热点 - 51吃瓜官网",
    tdkDescription: "51吃瓜官网社会热点频道，追踪社会民生热点事件与公共话题，提供及时、真实、有深度的社会新闻资讯。",
    tdkKeywords: "社会热点,民生新闻,社会事件,公共话题,51吃瓜官网",
  },
  {
    key: "netfun",
    slug: "netfun",
    name: "网络趣闻",
    shortName: "趣闻",
    icon: "ri-emotion-happy-line",
    description: "网罗全网轻松有趣的段子、奇闻与暖心故事，让碎片时间也能会心一笑。",
    tdkTitle: "网络趣闻 - 51吃瓜官网",
    tdkDescription: "51吃瓜官网网络趣闻频道，网罗全网轻松有趣的段子、奇闻与暖心故事，轻松浏览网络热点趣事。",
    tdkKeywords: "网络趣闻,趣味新闻,网络热点,搞笑段子,51吃瓜官网",
  },
];